import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons";

import { DESK_COMMUNICATION_EVENTS } from "../../../../../../util/communication_statuses";

import "./index.scss";

const Signature = ({ events }) => {
  if (!events?.length) return null;

  const event = events.find(e => e.type === DESK_COMMUNICATION_EVENTS.CHECKIN_ANSWERED);
  if (!event?.customer_signature) return null;

  return (
    <div className="desk-comm-signature">
      {event.customer_name && (
        <div className="desk-comm-signature-name">
          <FontAwesomeIcon icon={faUser} className="i-green" />
          <span>{event.customer_name}</span>
        </div>
      )}
      <div className="desk-comm-signature-img-wrapper">
        <img src={event.customer_signature} alt="signature" className="desk-comm-signature-img" />
      </div>
    </div>
  );
};

export default Signature;
